import React, { Fragment, useEffect, useState } from "react";
import {
  Grid,
  Typography,
  TableBody,
  Table,
  TableContainer,
  Chip,
  TablePagination,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";

import StyledTableCell from "../../../../styles/tableCell";
import styles from "../../../../styles/global-styles";
import StyleTableRow from "../../../../styles/styleTableRow";
import StatelessTableHeadProduct from "../../../stateless/headTables/StatelessTableHeadProduct";
import { actions } from "../../../../redux/actions/alert";
import { changeRowsPerPage } from "../../../../_utils/utils";
import {
  getAccesoriesByFilters,
  searchAccesoryByBarCode,
} from "../utils.inventory";
import AccesoryByBarCode from "../../modals/AccesoryByBarCode";
import { AccesoryService } from "../../../../services/accesory.service";
import BackDrop from "../../../shared/backdrop/Backdrop";
import AccesoryHeaderBySite from "./headers/AccesoryHeaderBySite";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  customSelect: styles.customSelect,
  subtitle: styles.subtitle,
  row: styles.rowHover,
  chip: styles.chip,
  lowExistence: styles.lowExistence,
  mediumExistence: styles.mediumExistence,
  highExistence: styles.highExistence,
}));

const AccesoryInventory = ({ history: { push }, addAlert, detailAlert }) => {
  const classes = useStyles();
  const theme = useTheme();

  const [accesoriesArray, setaccesoriesArray] = useState({});
  const [productsAvailable, setProductsAvailable] = useState(false);
  const [queryParams, setqueryParams] = useState({});

  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  useEffect(() => {
    (async function fetchData() {
      /** Service for fill data table */
      try {
        if (Object.values(queryParams).length) {
          recoverAccesoriesWithParams();
        } else {
          setProductsAvailable(false);
          const body = {
            page,
            limit: rowsPerPage,
          };
          console.log("query params", body);
          const { accesories, count } = await getAccesoriesByFilters(
            body,
            false
          );
          console.log("ALL accesories in table", accesories);
          console.log("count", count);
          setaccesoriesArray({ accesories, count });
          setProductsAvailable(true);
          return () => {
            setaccesoriesArray({});
          };
        }
      } catch (error) {
        console.log(error);
        addAlert({ showAlert: true });
        detailAlert({
          severity: "error",
          message:
            error.msgs ||
            error.notFoundMsg ||
            "Error al recuperar productos para mostrar en tabla",
        });
        setProductsAvailable(true);
      }
    })();
  }, [page, rowsPerPage]);

  const recoverAccesoriesWithParams = async () => {
    setProductsAvailable(false);
    try {
      const body = {
        ...queryParams,
        inDistribution: 0,
        page,
        limit: rowsPerPage,
      };
      console.log("queryParams", body);
      const {
        data: { accesories, count },
      } = await AccesoryService.getAccesoriesBySitesAndStoreParamsPaginated(
        body
      );
      console.log("accesories WITH queryParams", accesories);
      console.log("accesories length ", count);

      if (accesories.length) {
        setaccesoriesArray({ accesories, count });
        setProductsAvailable(true);
      } else {
        const error = {
          notFoundMsg:
            "No se encontraron accesorios con los filtros seleccionados",
        };
        throw error;
      }
    } catch (error) {
      console.log("error searchProductByFilters", error);
      throw error;
    }
  };

  const goToUrl = (url, { brand, model, barCode }) =>
    // al moverlo a CONTAINER fijarse en siteId
    push(url, { brand, model, productTypeId: 2, barCode });

  const handleRowsPerPage = (event) => {
    const { rowsPerPage, page } = changeRowsPerPage(event);
    setRowsPerPage(rowsPerPage);
    setPage(page);
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleAccesoriesByFilter = (accesoriesFound) => {
    const { accesories, count, queryParams } = accesoriesFound;
    setaccesoriesArray({ accesories, count });
    setqueryParams(queryParams);
    setPage(0);
  };

  return (
    <Fragment>
      <AccesoryHeaderBySite
        storeInventory
        accesoriesFound={handleAccesoriesByFilter}
      />

      <Grid style={{ marginTop: theme.spacing(3) }}>
        <TableContainer>
          <Table className={classes.table} aria-label="customized table">
            <StatelessTableHeadProduct isAccesory={true} singleSite={false} />
            <TableBody>
              {productsAvailable &&
                accesoriesArray.accesories?.map((row, i) => (
                  <StyleTableRow
                    key={i}
                    className={classes.row}
                    onClick={() =>
                      goToUrl("/dashboard/inventario/detalle-producto", row)
                    }
                  >
                    <StyledTableCell align="center">
                      {row.brand}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.model}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip
                        label={
                          row["name"] ||
                          row["subcategory_type.name"] ||
                          "No definido"
                        }
                        className={classes.chip}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.barCode}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <NumberFormat
                        value={row.cost}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <NumberFormat
                        value={row.price}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.discount ? (
                        <NumberFormat
                          value={row.discount || "N/A"}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      ) : (
                        "N/A"
                      )}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip
                        label={row.availablesInStore}
                        className={
                          row.availablesInStore <= 3
                            ? classes.lowExistence
                            : row.availablesInStore <= 7
                            ? classes.mediumExistence
                            : classes.highExistence
                        }
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip
                        label={row.availablesInSite}
                        className={
                          row.availablesInSite <= 3
                            ? classes.lowExistence
                            : row.availablesInSite <= 7
                            ? classes.mediumExistence
                            : classes.highExistence
                        }
                      />
                    </StyledTableCell>
                  </StyleTableRow>
                ))}
            </TableBody>
          </Table>
          {!accesoriesArray.accesories?.length === 0 && (
            <Typography
              variant="h6"
              component="h4"
              style={{ marginTop: 50 }}
              className={classes.subtitle}
            >
              No hay productos en el inventario
            </Typography>
          )}
        </TableContainer>
        {accesoriesArray.count > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={accesoriesArray.count}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={(event) => handleRowsPerPage(event)}
          />
        )}
      </Grid>

      {!productsAvailable && (
        <BackDrop
          style={{
            zIndex: 1,
            color: "#1C2668",
          }}
          isOpen={!productsAvailable}
        />
      )}
    </Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(AccesoryInventory);
